import { Card } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Typography from '@classify/react-core-components/Typography';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ breakpoints, spacing, palette, shadows }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      color: palette.text.onMainSecondary,
      boxShadow: shadows.banner,
      width: 268,
      height: '100%',
      textAlign: 'center',
      padding: spacing(3),
      [breakpoints.down('sm')]: {
        width: 240,
        padding: spacing(2),
      },
    },
    footer: {
      marginTop: 'auto',
    },
    picture: {
      display: 'block',
      borderRadius: '100%',
      marginRight: 'auto',
      marginLeft: 'auto',
      marginBottom: spacing(2),
      width: 96,
      height: 96,
      [breakpoints.down('sm')]: {
        width: 80,
        height: 80,
      },
    },
    quote: {
      marginBottom: spacing(2),
      color: palette.text.onMain,
    },
    user: {
      color: palette.text.onMain,
      marginBottom: spacing(2),
    },
    caption: {
      color: palette.text.inactive,
    },
  })
);

export default function UserTestimonyItem({
  classes: customClasses = {},
  children,
  pictureUrl,
  userJob = '',
  userTitle,
  userCaption = '',
}) {
  const classes = useStyles({ classes: customClasses });

  return (
    <Card className={classes.root}>
      <img className={classes.picture} src={pictureUrl} alt="" />
      <Typography variant="h3" component="span" className={classes.user}>
        {userTitle}
      </Typography>
      <Typography variant="bodySmall" component="blockquote" className={classes.quote}>
        {children}
      </Typography>

      <div className={classes.footer}>
        {userJob && (
          <Typography
            variant="overline"
            sx={{ textTransform: 'uppercase', color: 'text.onMainSecondary' }}
            component="div"
          >
            {userJob}
          </Typography>
        )}

        {userCaption && (
          <Typography variant="caption" component="div" className={classes.caption}>
            {userCaption}
          </Typography>
        )}
      </div>
    </Card>
  );
}
